import { ISteps } from './Stepper';
import { Grid, Typography } from '@ts/storybook';
import { TMode } from '@ts/ui-models';

interface PreviewStepperProps {
  mode: TMode;
  steps: ISteps[];
  formData: any;
  requiredFields: string[];
}

const PreviewStepper = (props: PreviewStepperProps) => {
  return (
    <Grid container p={2} pt={0}>
      {props.steps.map((s, i) => (
        <Grid size={{ xs: 12 }} key={i} mt={i !== 0 ? 4 : 0}>
          <Typography variant="h6" text={s.label} />
          <div key={i} className="ml-4 mt-2">
            {<s.formComponent {...props} isPreview />}
          </div>
        </Grid>
      ))}
    </Grid>
  );
};
export default PreviewStepper;
